<template>
    <div class="x-bar">
        <div :id="id"
             :option="option"></div>
    </div>
</template>

<script>
    import HighCharts from 'highcharts'
    import HighChartsMore from 'highcharts/highcharts-more';
    HighChartsMore(HighCharts);
    export default {
        name: "chart",
        props: {
            id: String,
            option: Object

        },
        mounted() {
            HighCharts.chart(this.id,this.option)
        }
    }
</script>

<style scoped>

</style>